





















import {Component, Vue, Prop, Watch} from 'vue-property-decorator';

@Component({
  name: 'header-cart'
})

export default class extends Vue {
  @Prop() readonly label: string;
  @Prop() readonly quoteItemCount: number;

  private itemCount: number = 0;

  private enableTransition: boolean = false;
  private initialRender: boolean = true;

  @Watch('itemCount')
  private handleWishlistCount(): void {

    if (this.initialRender) {
      this.initialRender = false;
      return;
    }

    this.enableTransition = true;
    setTimeout(() => {
      this.enableTransition = false;
    }, 300);
  }
  protected created() {
    this.itemCount = this.quoteItemCount;

    window.addEventListener('CheckoutAddedProductToCartEvent', (payload) => {
      this.itemCount = +this.itemCount + +payload['detail'];
    })
  }
}
